import { $ } from '../test/utilities/jQuerySource';
import { CSS_MIME_TYPE, JS_MIME_TYPE } from './utility/mime.helpers';

let loadPromises = {};
let scriptConfigs = {};
let hashFunction;

// temporary fix to get getScript() to use caching
$?.ajaxSetup({ cache: true });

export const ATTR_NAME_RESOURCE_NAME = 'data-fv-resource-name';

// String -> Promise
export const loadStylesheet = (url, { resourceName } = {}) =>
    new Promise((resolve, reject) => {
        let linkElement = document.createElement('link');
        linkElement.type = CSS_MIME_TYPE;
        linkElement.rel = 'stylesheet';
        linkElement.href = url;

        if (resourceName) {
            linkElement.setAttribute(ATTR_NAME_RESOURCE_NAME, resourceName);
        }

        linkElement.onload = () => resolve();
        linkElement.onerror = (e) => {
            const errorMessage =
                e?.message || 'Unspecified error while loading stylesheet.';

            reject(new Error(errorMessage));
        };

        document.head.appendChild(linkElement);
    });

// String -> Promise
export const loadScript = (url) =>
    new Promise((resolve, reject) => {
        let scriptElement = document.createElement('script');
        scriptElement.type = JS_MIME_TYPE;
        scriptElement.src = url;
        scriptElement.async = true;

        scriptElement.onload = () => resolve();
        scriptElement.onerror = (e) => {
            const errorMessage =
                e?.message || 'Unspecified error while loading script.';

            reject(new Error(errorMessage));
        };

        document.head.appendChild(scriptElement);
    });

// String -> Promise
const loadScriptLegacy = function (url) {
    return new Promise(function (res, rej) {
        $.getScript(url).then(res, function (x, m, e) {
            rej(e.message ? e : new Error(e));
        });
    });
};

function registerScript(key, settings) {
    scriptConfigs[key] = settings;
}

const initLoadScript = async (key) => {
    const { dependencies = [], url, get } = scriptConfigs[key];
    const hash = hashFunction && hashFunction();

    for (const dependency of dependencies) {
        // eslint-disable-next-line no-use-before-define -- Mutually recursive functions
        await ensureScript(dependency);
    }

    await loadScriptLegacy(url + (hash ? '?v=' + hash : ''));

    return get ? get() : null;
};

const ensureScript = async (key) => {
    if (!loadPromises[key]) {
        loadPromises[key] = initLoadScript(key);
    }

    return await loadPromises[key];
};

function setHashFunction(value) {
    hashFunction = value;
}

export { ensureScript, registerScript, setHashFunction };
